var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "email-template-filter-toolbar" },
    [
      _c(
        "CommonFilterTool",
        {
          attrs: {
            "keep-state-on-query-params": false,
            "filter-meta": _vm.filterMetas,
            "label-formatter": _vm.filterLabelFormatter,
          },
          on: { addFilter: _vm.addFilter, "clear-all": _vm.clearAllFilters },
          model: {
            value: _vm.emailTemplateFilter,
            callback: function ($$v) {
              _vm.emailTemplateFilter = $$v
            },
            expression: "emailTemplateFilter",
          },
        },
        [_c("template", { slot: "extra" }, [_vm._t("extra")], 2)],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }